module.exports = __webpack_public_path__ + "img/logo.08ee5ca5.png";